<template>
    <div  class="inline-block " style="user-select: none;">
        <!-- Click area -->
        <div @click="toggleDropdown"  class="items-center h-16 px-4 border-t border-black cursor-pointer flex justify-between">
            <p class="small m-0">
            {{menuItem.title}}
            </p>
            <UiOpen class="close w-3" :class="{'open': dropdownOpen}" :forceHover="dropdownOpen"/>
        </div>

        <!-- Dropdown-lista med egna boxar -->
        <transition name="grow-in">
        <ul v-if="dropdownOpen" class="w-full overflow-hidden">
          <!-- :class for margin bottom at last submenuitem -->
          <li 
              v-for="subitem in menuItem.items" 
              :key="subitem.url"
              class="pt-2 pb-4 pl-8 m-0 xsmall hover:bg-gravaalightwarmgray cursor-pointer flex"
              :class="{'mb-3': menuItem.items[menuItem.items.length - 1] === subitem}"
              >
              <NuxtLink :to="menuStore.stripDomain(subitem.url).replace('/collections/', '/shop/')" class="w-full">
              {{ subitem.title }}
              </NuxtLink>
              
          </li>
        </ul>
        </transition>
    </div>
</template>
  
<script setup>
  import { useMenuStore } from "@/stores/menuStore";
  import { ref, defineAsyncComponent } from 'vue';
  const UiOpen = defineAsyncComponent(() => import('@/components/ui/open.vue'));
  const menuStore = useMenuStore();
  
  // Props
  const props = defineProps({
    menuItem: {
      type: Object,
      required: true
    }
  });
  

  const dropdownOpen = ref(false);
  
  function toggleDropdown() {
    
    dropdownOpen.value = !dropdownOpen.value;
  }
  
  
  </script>
  